import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import { AppStoreHomeProvider } from '../../features/apps/context/AppStoreHomeContext';
import StudioPage from '../../features/studio/components/StudioPage';

const StudioRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <AppStoreHomeProvider>
        <StudioPage />
      </AppStoreHomeProvider>
    </ProtectedRoute>
  );
};

export default StudioRoute;

